<template>
  <div>
    <h3 class="account-sub-title d-none d-md-block mt-0 pt-1 ml-1">
      <i class="icon-user-2 align-middle mr-3 pr-1"></i>
      {{ translations.updateAddress }}
    </h3>
    <div class="account-content">
      <form @submit.prevent="updateShippingInfo">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="country">
                {{ translations.state }}
                <span class="required">*</span>
              </label>
              <div class="select-custom">
                <vue-select
                  :options="countries"
                  v-model="countryId"
                  :custom-label="customLabel"
                  @search-change="getCountries"
                  id="id"
                  :loading="isLoading"
                  @select="getTownsByCountryId"
                  :placeholder="translations.chooseState"
                >
                  <template slot="noOptions"> {{ translations.listIsEmpty }} </template>
                  <template slot="noResult">
                     {{ translations.noResultsAccordingToTheGivenParameters }} </template>
                </vue-select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="town">
                {{ translations.forms.labels.town }}
                <span class="required">*</span>
              </label>

              <vue-select
                :options="towns"
                v-model="townId"
                :custom-label="customLabel"
                @search-change="getTowns"
                id="id"
                :loading="isLoading"
                :placeholder="translations.chooseTown"
              >
                <template slot="noOptions"> {{ translations.listIsEmpty }} </template>
                <template slot="noResult">
                   {{ translations.noResultsAccordingToTheGivenParameters }} </template>
              </vue-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="zip-code">
                {{ translations.zipCode }}
                <span class="required">*</span>
              </label>
              <input
                v-model="address.zipCode"
                type="text"
                class="form-control"
                :placeholder="translations.zipCode"
                id="zip-code"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="address">
                {{ translations.forms.labels.address }}
                <span class="required">*</span>
              </label>
              <input
                v-model="address.address"
                type="text"
                class="form-control"
                id="address"
                :placeholder="translations.forms.labels.address"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="phone">
                {{ translations.phoneNumber }}
                <span class="required">*</span>
              </label>
              <input
                v-model="address.phoneNumber"
                type="text"
                class="form-control"
                :placeholder="translations.phoneNumber"
                id="phone"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  v-model="address.isDefault"
                  class="custom-control-input"
                  id="is-default-address"
                />
                <label class="custom-control-label" for="is-default-address">
                  {{ translations.defaultAddress2 }}?
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-footer mt-3 mb-0">
          <button type="submit" class="btn btn-primary mr-0">{{ translations.save }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-multiselect';

import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'EditAddress',
  mixins: [translations],
  components: {
    VueSelect,
  },
  data() {
    return {
      isLoading: false,
      countryId: {},
      townId: {},
    };
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.map(({ id, title }) => ({ id, title }));
    },
    towns() {
      return this.$store.getters.getTowns;
    },
    address() {
      return this.$store.getters.getShippingAddress;
    },
  },
  methods: {
    customLabel({ title }) {
      return title;
    },
    getCountries(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getCountries', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    getTownsByCountryId({ id }) {
      this.$store
        .dispatch('getTowns', {
          countryId: id,
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getTowns(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getTowns', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    onCountryChange() {
      this.townId = null;
      this.$store.dispatch('getTowns', {
        sortBy: 'title',
        isSortAscending: false,
        retrieveAll: true,
        countryId: this.countryId,
      });
    },
    updateShippingInfo() {
      const payload = {
        ...this.address,
        countryId: this.countryId.id,
        townId: this.townId.id,
      };

      api
        .updateShippingAddress(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Address' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getShippingAddress', parseInt(this.$route.params.id, 10)).then((response) => {
      this.countryId = {
        id: response.countryId,
        title: response.country,
      };

      this.townId = {
        id: response.townId,
        title: response.town,
      };
      this.$store.dispatch('getCountries', {
        sortBy: 'title',
        isSortAscending: false,
        retrieveAll: true,
        mustIncludeId: response.countryId,
      });
      this.$store.dispatch('getTowns', {
        sortBy: 'title',
        isSortAscending: false,
        retrieveAll: true,
        mustIncludeId: response.townId,
      });
    });
  },
};
</script>
